export default {"src":"/_next/static/image/public/images/woman.798576edfc7b517c498cb82861b4f72d.svg","height":58,"width":58};